import { AfterViewInit, Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { IPopup } from '../IPopup';

@Component({
  selector: 'app-disable-mobile-data-popup',
  templateUrl: './disable-mobile-data-popup.component.html',
  styleUrls: ['./disable-mobile-data-popup.component.scss'],
})
export class DisableMobileDataPopupComponent implements OnInit, AfterViewInit, IPopup {
  @ViewChild('basePopup') basePopup: BasePopupComponent;
  @Input() isReminder = false;
  public onCancel = undefined;
  public onOk = undefined;
  public popupName = 'DisableMobileData';
  public closed: EventEmitter<void> = new EventEmitter();

  constructor(public l: LanguageService) {}

  ngOnInit(): void {}
  ngAfterViewInit() {}

  public show() {
    this.basePopup.show();
  }

  public close() {
    this.basePopup.hidePopup();
  }

  public doCancel() {
    if (this.onCancel !== undefined) {
      this.onCancel();
    }
  }

  public doOk() {
    if (this.onOk !== undefined) {
      this.onOk();
    }
  }
}
